import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function completeDetailsUpdate(playerId, shirt_size, grade) {
  const token = Cookies.getToken();

  const res = await axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/api/users/players/${playerId}/complete_details/`,
    headers: { Authorization: `Bearer ${token}` },
    data: { shirt_size, grade },
  });

  return res;
}

